webpackJsonp([280940121040016],{

/***/ 1201:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ActionsEnum","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"DELETE"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"INSERT"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"UPDATE"}],"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---enum-actions-enum-89271557643ee86c4bda.js